import React, { useEffect, useState } from 'react';
import { getSpeciesSummary } from '../../services/stewardshipService';

export default function StewardshipSpeciesSummary({ tenantId, refreshKey = 0 }) {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [revision, setRevision] = useState(0);
  useEffect(() => {
    let current = true;
    setRows([]); setError(''); setLoading(true);
    if (!tenantId) { setLoading(false); return undefined; }
    getSpeciesSummary(tenantId)
      .then((response) => { if (current) setRows(response.data); })
      .catch((err) => { if (current) setError(err.response?.data?.message || 'Could not load species record counts.'); })
      .finally(() => { if (current) setLoading(false); });
    return () => { current = false; };
  }, [tenantId, refreshKey, revision]);
  return <details style={{ marginBottom: 16 }}>
    <summary>Community species record counts</summary>
    <p>Harvest entries count all saved records, including quality-flagged entries and legacy statuses, not individual animals or quantity. Guidance counts non-archived species/season assignments, including drafts and assignments on archived boundaries; it is not a count of published areas. Species with neither are omitted. Older name-only harvests are not linked and are excluded.</p>
    <button type="button" disabled={loading} onClick={() => setRevision((value) => value + 1)}>Refresh counts</button>
    {loading && <p role="status">Loading species counts...</p>}
    {error && <p role="alert">{error}</p>}
    {!loading && !error && (rows.length ? <table>
      <thead><tr><th>Species</th><th>Harvest entries</th><th>Guidance assignments</th></tr></thead>
      <tbody>{rows.map((row) => <tr key={row.speciesId}><td>{row.name}</td><td>{row.harvestRecords}</td><td>{row.guidanceAssignments}</td></tr>)}</tbody>
    </table> : <p>No species-linked records in this community yet.</p>)}
  </details>;
}
